// Answers state facts taken from the current site.
export const faqs = [
  {
    q: "Where is RollOver?",
    a: "RollOver is in Chaitanyapuri Colony, Hanamkonda, Warangal, opposite Tara Gardens. The Find Us page has the map and a directions link.",
    link: { to: "/find-us", label: "Open Find Us" },
  },
  {
    q: "What are the café’s opening hours?",
    a: "RollOver is open Monday to Friday 11am–11pm and Saturday and Sunday 10am–11pm.",
  },
  {
    q: "Can I order online?",
    a: "Yes. Use the Order online action to open RollOver’s Swiggy or Zomato listing. Delivery area and payment are handled there.",
  },
  {
    q: "Where do I see delivery prices?",
    a: "The Swiggy or Zomato listing shows the live delivery price for every item.",
  },
  {
    q: "Is every dish shown here available?",
    a: "The seven featured dishes are our highlights. The full menu page lists every category.",
    link: { to: "/menu/c/ice-cream-rolls", label: "Browse the full menu" },
  },
  {
    q: "Where can I check ingredients?",
    a: "Open a dish page and expand Show dish details. For full ingredient lists, ask the café directly.",
  },
  {
    q: "What should I do about allergens?",
    a: "Ask the café about ingredients, allergens and cross-contact before ordering. Nothing on this site establishes that a dish is allergen-free.",
  },
  {
    q: "Are vegetarian or non-vegetarian choices available?",
    a: "Yes. The full menu marks every item as vegetarian or non-vegetarian.",
    link: { to: "/menu/c/burgers", label: "See the full menu" },
  },
  {
    q: "Can I visit for a café break?",
    a: "Yes. RollOver is a dine-in café with delivery available. The Find Us page has the address and map.",
    link: { to: "/find-us", label: "Find Us" },
  },
  {
    q: "Can I book the café for a celebration?",
    a: "The events page describes in-store and outdoor celebrations and the booking form sends your request to the team by email. A booking is confirmed only when the team contacts you.",
    link: { to: "/book-event", label: "Book an event" },
  },
  {
    q: "Do you have special offers?",
    a: "Offers change. The offers page shows current promotional posters; terms, dates and eligibility are set by the café.",
    link: { to: "/offers", label: "See offers" },
  },
  {
    q: "How can I contact the café?",
    a: "Call or WhatsApp RollOver on +91 86880 66805. Social profiles are linked in the footer.",
    link: { to: "/find-us", label: "Contact details" },
  },
  {
    q: "Does this website place orders?",
    a: "No. Ordering links open RollOver’s Swiggy or Zomato listing, where the order is placed.",
  },
];
